function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "30",
  height: "30",
  viewBox: "0 0 30 30",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M9.926 28.431c.157.71-.345 1.4-1.123 1.543-.778.143-1.536-.315-1.693-1.023L1.029 1.588C.872.88 1.375.19 2.153.046 2.93-.098 3.688.36 3.846 1.069l6.08 27.362zM24.082 2.301C18.727 2.781 17.77.365 12.66.435c-2.921.04-5.823.745-7.27 1.268l3.628 16.33c.884-.288 2.18-.533 3.93-.415 2.32.157 3.188 1.687 8.379 1.33 3.732-.256 5.792-2.297 5.792-2.297L28.791.592s-1.041 1.38-4.709 1.71z",
  fill: "currentColor"
})));